import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "group relative inline-block"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = {
  class: "text-surface-600"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Button = _resolveComponent("Button");
  var _component_Menu = _resolveComponent("Menu");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Button, {
    icon: "fa-regular fa-language ",
    variant: "text",
    severity: "contrast",
    "aria-haspopup": "true",
    "aria-controls": "icon_menu",
    onClick: $options.toggleMenu,
    size: "small",
    pt: {
      root: {
        class: 'hover:!bg-surface-100'
      },
      icon: {
        class: '!text-surface-700'
      }
    }
  }, null, 8, ["onClick"]), _createVNode(_component_Menu, {
    ref: "menu",
    model: $options.languages,
    popup: "",
    class: "z-50 text-xs"
  }, {
    item: _withCtx(function (_ref) {
      var item = _ref.item;
      return [_createElementVNode("div", {
        class: "p-2 cursor-pointer hover:!bg-surface-200 focus:!bg-surface-200 selected:!bg-surface-200 rounded-sm",
        onClick: function onClick($event) {
          return $options.changeLanguage(item.value);
        }
      }, [_createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1)], 8, _hoisted_2)];
    }),
    _: 1
  }, 8, ["model"])]);
}